export default "/react/gear-fa68eaa1.png";